module.exports = __webpack_public_path__ + "img/top2.058386a0.png";